<template>
  <div id="recipeSearch" v-if="$store.state.user.scope">


    <mu-card>

      <mu-card-text>

        <input class="search-control" type="text" placeholder="Search by; title, ingredient or category"
               v-model="model.q" @keydown="handleSearchKeydown"/>


        <h2>Cooking time</h2>

        <mu-row gutter>
          <mu-col width="50" tablet="50" desktop="50" align="center">
            <mu-chip class="cooking-time-chip" style="margin-bottom: 16px"
                     :class="{'active': timeFilter === 'underTenMin'}" @click.native="setUnder10Min()">
              0 - 10 min
            </mu-chip>
            <mu-chip class="cooking-time-chip" style="margin-bottom: 16px"
                     :class="{'active': timeFilter === 'underThirtyMinOverTen'}"
                     @click.native="setUnderThirtyMinOverTen()">
              Under 30 min
            </mu-chip>
          </mu-col>
          <mu-col width="50" tablet="50" desktop="50" align="center">
            <mu-chip :class="{'active': timeFilter === 'underHourOver30'}" class="cooking-time-chip"
                     style="margin-bottom: 16px;" @click.native="setUnderHourOver30()">
              30 min - 1 hour
            </mu-chip>
            <mu-chip :class="{'active': timeFilter === 'overHour'}" class="cooking-time-chip"
                     @click.native="setOverHour()">
              Over 1 hour
            </mu-chip>
          </mu-col>
        </mu-row>


        <div class="bottom">
          <vue-slider v-if="model.totaltime.length > 0" :speed="0" @drag-end="checkChanged" v-bind="timeSlider"

                      v-model="model.totaltime"></vue-slider>
        </div>
        <mu-row class="bottom">
          <mu-col desktop="50" tablet="50" width="50" align="left">
            {{ model.totaltime[0] }} min(s)
          </mu-col>
          <mu-col desktop="50" tablet="50" width="50" align="right">
            {{ model.totaltime[1] }} min(s)
          </mu-col>
        </mu-row>


        <h2>Nutrition</h2>


        <div class="bottom">
          <div>Carbohydrate <span class="floatRight">{{ model.carbs[0] + ' - ' + model.carbs[1] }}g</span></div>
          <vue-slider v-if="model.carbs.length > 0" @drag-end="checkChanged"
                      v-bind="carbSlider" v-model="model.carbs"></vue-slider>

        </div>
        <div class="bottom">
          <div>Fat <span class="floatRight">{{ model.fat[0] + ' - ' + model.fat[1] }}g</span></div>
          <vue-slider v-if="model.fat.length > 0" @drag-end="checkChanged"
                      v-bind="fatSlider" v-model="model.fat"></vue-slider>
        </div>
        <div class="bottom">
          <div>Calories <span class="floatRight">{{ model.calories[0] + ' - ' + model.calories[1] }}kcal</span></div>
          <vue-slider v-if="model.calories.length > 0" :start-animation="false" @drag-end="checkChanged"
                      v-bind="calorieSlider" v-model="model.calories"></vue-slider>
        </div>
        <div class="bottom">
          <div>Protein <span class="floatRight">{{ model.protein[0] + ' - ' + model.protein[1] }}g</span></div>
          <vue-slider v-if="model.protein.length > 0" :start-animation="false" @drag-end="checkChanged"
                      v-bind="proteinSlider" v-model="model.protein"></vue-slider>

        </div>

        <h2>Dietary types</h2>
        <mu-row>
          <mu-col width="50" tablet="100" :desktop="fullWidth === true ? '50': '25'"
                  v-for="item, dietaryTypeI in model.dietaryTypes"
                  :key="'dietaryType-' + dietaryTypeI">
            <mu-checkbox @change="checkChanged" v-model="item.checked" :label="item.label">{{ item.label }}
            </mu-checkbox>
          </mu-col>
        </mu-row>
        <h2>Categories</h2>
        <mu-row>
          <mu-col width="50" tablet="100" :desktop="fullWidth === true ? '50': '25'"
                  v-for="item, catI in model.categories" :key="'category-' + catI">
            <mu-checkbox @change="checkChanged" v-model="item.checked" :label="item.label">{{ item.label }}
            </mu-checkbox>
          </mu-col>
        </mu-row>


        <div v-if="!additionalOptions && fullWidth" style="margin-top:16px;margin-bottom: 16px;">
          <mu-raised-button label="More filters" @click.native="additionalOptions = !additionalOptions"
                            :full-width="true"></mu-raised-button>
        </div>
        <div v-if="additionalOptions && fullWidth" style="margin-top:16px;margin-bottom: 16px;">
          <mu-raised-button label="Hide filters" @click.native="additionalOptions = !additionalOptions"
                            :full-width="true"></mu-raised-button>
        </div>


        <div v-show="additionalOptions">

          <h2>Allergies</h2>
          <mu-row>
            <mu-col width="50" tablet="100" :desktop="fullWidth === true ? '50': '25'"
                    v-for="item, suitabilityI in model.suitabilities"
                    :key="'suitability-' + suitabilityI">
              <mu-checkbox @change="checkChanged" v-model="item.checked" :label="item.label">{{ item.label }}
              </mu-checkbox>
            </mu-col>
          </mu-row>

          <h2>Cuisines</h2>
          <mu-row>
            <mu-col width="50" tablet="100" :desktop="fullWidth === true ? '50': '25'"
                    v-for="item, cuisineI in model.cuisines"
                    :key="'cuisine-' + cuisineI">
              <mu-checkbox @change="checkChanged" v-model="item.checked" :label="item.label">{{ item.label }}
              </mu-checkbox>
            </mu-col>
          </mu-row>

          <h2>Occasions</h2>
          <mu-row class="bottom">
            <mu-col width="50" tablet="100" :desktop="fullWidth === true ? '50': '25'"
                    v-for="item, occasionI in model.occasions"
                    :key="'occasion-' + occasionI">
              <mu-checkbox @change="checkChanged" v-model="item.checked" :label="item.label">{{ item.label }}
              </mu-checkbox>
            </mu-col>
          </mu-row>
        </div>

        <mu-raised-button :disabled="isSearching" @click.native="submitSearch" secondary
                          :label="isSearching === true ? $t('message.loadingText') : $t('message.searchText')"
                          fullWidth></mu-raised-button>
      </mu-card-text>
    </mu-card>
  </div>
</template>

<script>
import axios from 'axios'
import vueSlider from 'vue-slider-component/src/vue2-slider.vue'
import RecipeFilterMixin from './Mixins/Filter'
import RecipeApi from '../../api/Recipes'
import MuRaisedButton from "muse-ui/src/raisedButton/raisedButton";
import MuCheckbox from "muse-ui/src/checkbox/checkbox";


export default {
  mixins: [RecipeFilterMixin],
  components: {
    MuCheckbox,
    MuRaisedButton,
    vueSlider
  },
  name: "recipe-search",
  props: ['filterData', 'categories', 'fullWidth', 'isResultsPage'],
  watch: {
    '$route': 'getTypes'
  },
  data() {
    return {
      timeFilter: '',
      isSearching: false,
      sliderOptions: {
        carbs: {
          min: 0,
          max: 500,
          trackColor: 'rgb(126, 211, 33)',
          backgroundColor: 'rgba(126, 211, 33, 0.3)',
          range: true
        },
        fat: {
          min: 0,
          max: 500,
          trackColor: 'rgb(60, 177, 255)',
          backgroundColor: 'rgba(60, 177, 255, 0.3)',
        },
        calories: {
          min: 0,
          max: 6000,
          trackColor: 'rgb(80, 227, 194)',
          backgroundColor: 'rgba(80, 227, 194, 0.3)',
        },
        protein: {
          min: 0,
          max: 500,
          trackColor: 'rgb(255, 94, 7)',
          backgroundColor: 'rgba(255, 94, 7, 0.3)',
        },
        totaltime: {
          min: 0,
          max: 200,
          trackColor: 'rgb(255, 94, 7)',
          backgroundColor: 'rgba(255, 94, 7, 0.3)'
        }
      },
      model: {
        q: null,
        suitabilities: [],
        dietaryTypes: [],
        cuisines: [],
        categories: [],
        carbs: [0, 500],
        fat: [0, 700],
        calories: [0, 6000],
        protein: [0, 500],
        totaltime: [0, 200]
      },
      sliderSettings: {
        interval: 1,
        disabled: false,
        tooltip: false,
        startAnimation: false
      },
      additionalOptions: true
    }
  },
  mounted() {
    let self = this;
    self.$store.commit('setRecipeSearchFilter', self.model);


    if (self.fullWidth) {
      this.additionalOptions = false;
    }

    if (_.has(self.$route.query, 'search')) {
      self.model.q = self.$route.query.search
    }

    if (_.has(self.$route.query, 'totaltimelte') && _.has(self.$route.query, 'totaltimegte')) {
      self.model.totaltime = [parseInt(self.$route.query.totaltimegte), parseInt(self.$route.query.totaltimelte)];
    }

    if (_.has(self.$route.query, 'carbgte') && _.has(self.$route.query, 'carblte')) {
      self.model.carbs = [parseInt(self.$route.query.carbgte), parseInt(self.$route.query.carblte)];
    }

    if (_.has(self.$route.query, 'fatgte') && _.has(self.$route.query, 'fatlte')) {
      self.model.fat = [parseInt(self.$route.query.fatgte), parseInt(self.$route.query.fatlte)];
    }

    if (_.has(self.$route.query, 'caloriesgte') && _.has(self.$route.query, 'calorieslte')) {
      self.model.calories = [parseInt(self.$route.query.caloriesgte), parseInt(self.$route.query.calorieslte)];
    } else {
      self.model.calories = [0, 6000]
    }

    if (_.has(self.$route.query, 'proteinlte') && _.has(self.$route.query, 'proteingte')) {
      self.model.protein = [parseInt(self.$route.query.proteingte), parseInt(self.$route.query.proteinlte)];
    } else {
      self.model.protein = [0, 500];
    }

    self.$emit('filterModel', self.getValues());
    self.getTypes();
  },
  methods: {
    setUnder10Min() {
      this.timeFilter = "underTenMin"
      this.model.totaltime = [0, 10];
      this.checkChanged()
    },
    setUnderThirtyMinOverTen() {
      this.timeFilter = 'underThirtyMinOverTen';
      this.model.totaltime = [10, 30];
      this.checkChanged()
    },
    setUnderHourOver30() {
      this.timeFilter = 'underHourOver30';
      this.model.totaltime = [30, 60];
      this.checkChanged()
    },
    setOverHour() {
      let self = this;
      this.timeFilter = "overHour";
      this.model.totaltime = [60, self.sliderOptions.totaltime.max]
      this.checkChanged()
    },
    checkChanged() {
      //remove time filter tag check as user changed settings
      this.timeFilter = '';
      this.$emit('changed', this.model);
      this.$store.commit('setRecipeSearchFilter', this.model);
      if (this.isResultsPage === true) {
        this.$nextTick(function () {
          this.submitSearch();
        });
      }
    },
    getValues() {
      let self = this;
      let carbsGTE = self.model.carbs[0], carbsLTE = self.model.carbs[1];
      let fatGTE = self.model.fat[0], fatLTE = self.model.fat[1];
      let caloriesGTE = self.model.calories[0], caloriesLTE = self.model.calories[1];
      let proteinGTE = self.model.protein[0], proteinLTE = self.model.protein[1];
      let totaltimeGTE = self.model.totaltime[0], totaltimeLTE = self.model.totaltime[1];
      return {
        search: self.model.q,
        page: 0,
        limit: 15,
        carblte: carbsLTE,
        carbgte: carbsGTE,
        fatlte: fatLTE,
        fatgte: fatGTE,
        totaltimegte: totaltimeGTE,
        totaltimelte: totaltimeLTE === 200 ? 750 : totaltimeLTE,
        caloriesgte: caloriesGTE,
        calorieslte: caloriesLTE,
        proteingte: proteinGTE,
        proteinlte: proteinLTE,
        suitabilities: self.getChecked('suitabilities').join(','),
        dietaryTypes: self.getChecked('dietaryTypes').join(','),
        cuisines: self.getChecked('cuisines').join(','),
        occasions: self.getChecked('occasions').join(','),
        categories: self.getChecked('categories').join(',')
      };
    },
    handleSearchKeydown(event) {
      if (event.keyCode === 13) {
        this.submitSearch();
      }
    },
    submitSearch() {
      let self = this;
      self.isSearching = true;
      if (RecipeApi.CancelRequests !== null) {
        RecipeApi.CancelRequests();
      }
      this.$emit('isSearching', this.isSearching);
      RecipeApi.search(self.clearQueryParameters(this.getValues()))
        .then((response) => {
          RecipeApi.CancelRequests = null;
          self.isSearching = false;
          self.$store.commit('setRecipeSearchFilter', self.model);
          this.$emit('recipeData', response.data);
          this.$nextTick(() => {
            this.$router.push({
              name: 'RecipeSearchResults',
              query: this.clearQueryParameters(this.getValues()),
              params: {
                data: response.data,
              }
            });
          })
        });
    },
    getChecked(key) {
      let self = this;
      let checkedItems = [];

      if (_.has(self.model, key)) {
        let checked = self.model[key].filter(function (item) {
          return item.checked === true;
        });
        checked.forEach(function (item) {
          checkedItems.push(item.label);
        });
        return checkedItems;
      } else return [];
    },
    checkOrUnCheck(array, bool) {
      let self = this;
      array.forEach(function (key) {
        self.model[key].forEach(function (item) {
          item.checked = bool;
          self.$forceUpdate();
        })
      })
    },
    getTypes() {
      let self = this;
      if (_.has(self.$route.query, 'search')) {
        self.model.q = self.$route.query.search;
      }

      if (this.filterData !== undefined) {
        if (_.has(self.$store.state.recipes.categories, 'suitabilities')) {
          self.model.suitabilities = self.$store.state.recipes.categories.suitabilities;
        }
        if (_.has(self.$store.state.recipes.categories, 'dietaryTypes')) {
          self.model.dietaryTypes = self.$store.state.recipes.categories.dietaryTypes;
        }
        if (_.has(self.$store.state.recipes.categories, 'cuisines')) {
          self.model.cuisines = self.$store.state.recipes.categories.cuisines;
        }
        if (_.has(self.$store.state.recipes.categories, 'categories')) {
          self.model.categories = self.$store.state.recipes.categories.categories;
        }
        if (_.has(self.$store.state.recipes.categories, 'occasions')) {
          self.model.occasions = self.$store.state.recipes.categories.occasions;
        }

      } else if (self.$store.state.recipes.categories) {


        self.model.suitabilities = self.$store.state.recipes.categories.suitabilities;
        self.model.dietaryTypes = self.$store.state.recipes.categories.dietaryTypes;
        self.model.cuisines = self.$store.state.recipes.categories.cuisines;
        self.model.categories = self.$store.state.recipes.categories.categories;
        self.model.occasions = self.$store.state.recipes.categories.occasions;


      } else {
        if (this.filterData === undefined) {
          axios.get("https://www.diabetes.co.uk/recipe-platform/api/recipe/utilities/alloptions")
            .then(function (response) {
              self.model.suitabilities = response.data.suitabilities;
              self.model.dietaryTypes = response.data.dietaryTypes;
              self.model.cuisines = response.data.cuisines;
              self.model.occasions = response.data.occasions;
              self.model.categories = response.data.categories;
              self.checkOrUnCheck(['suitabilities', 'dietaryTypes', 'cuisines', 'occasions', 'categories'], false);
              self.$store.commit('setRecipeCategories', {
                suitabilities: response.data.suitabilities,
                dietaryTypes: response.data.dietaryTypes,
                cuisines: response.data.cuisines,
                occasions: response.data.occasions,
                categories: response.data.categories,
              })
            });
        }
      }
    },
    assignSliderOptions(key) {
      let self = this;
      let {sliderSettings} = self;
      let sliderOptions = {
        min: self.sliderOptions[key].min,
        max: self.sliderOptions[key].max,
        speed: 0,
        startAnimation: false,
        bgStyle: {
          backgroundColor: self.sliderOptions[key].backgroundColor
        },
        processStyle: {
          backgroundColor: self.sliderOptions[key].trackColor
        }
      };
      return self.mergeSliderOptions(sliderSettings, sliderOptions)
    },
    mergeSliderOptions(sliderSettings, sliderValidation) {
      return Object.assign({}, sliderSettings, sliderValidation);
    }
  },
  computed: {
    timeSlider() {
      let self = this;
      return self.assignSliderOptions('totaltime')
    },
    carbSlider() {
      let self = this;
      return self.assignSliderOptions('carbs')
    },
    fatSlider() {
      return this.assignSliderOptions('fat')
    },
    calorieSlider() {
      return this.assignSliderOptions('calories')
    },
    proteinSlider() {
      return this.assignSliderOptions('protein')
    }
  }
}
</script>
<style lang="less">
.cooking-time-chip {
  border: 1px solid #0179d6;
  background: white !important;
  width: 100%;
}

.cooking-time-chip.active {
  background: #0179d6 !important;
  color: white !important;
}

#recipeSearch {
  .row {
    justify-content: flex-start;
  }

  .search-control {
    display: block;
    width: 100%;
    padding: 8px;
    margin-bottom: 14px;
    border-radius: 8px;
    border: 1px solid #dedede;
    cursor: pointer;

    &:focus {
      outline: none;
    }
  }

  .floatRight {
    float: right;
  }

  h2 {
    margin-top: 2px;
    color: #0179d5;
  }
}
</style>



// WEBPACK FOOTER //
// Search.vue?3e64e83e